import React, { useState } from 'react';
import { Modal, Form, Select, Input, InputNumber, Switch } from 'antd';

const alertTypes = [
  { value: 'keyword', label: 'Keyword' },
  { value: 'category', label: 'Category' },
  { value: 'merchant', label: 'Merchant' },
  { value: 'price_threshold', label: 'Price Threshold' },
  { value: 'any', label: 'Any Deal' },
];

export default function AlertForm({ open, onClose, onSubmit, initialValues }) {
  const [form] = Form.useForm();
  const [alertType, setAlertType] = useState(initialValues?.type || 'keyword');

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
    } catch {
      // validation failed
    }
  };

  return (
    <Modal
      title={
        <span style={{ fontFamily: 'var(--df-font-display)', fontWeight: 700 }}>
          {initialValues ? 'Edit Alert' : 'Create Alert'}
        </span>
      }
      open={open}
      onOk={handleOk}
      onCancel={() => { form.resetFields(); onClose(); }}
      okText={initialValues ? 'Update' : 'Create'}
      destroyOnClose
      okButtonProps={{
        style: {
          fontWeight: 600,
          borderRadius: 8,
          background: 'var(--df-accent)',
          borderColor: 'var(--df-accent)',
          minHeight: 40,
        },
      }}
      cancelButtonProps={{ style: { borderRadius: 8, minHeight: 40 } }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues || { type: 'keyword', frequency: 'realtime', isActive: true }}
        onValuesChange={(changed) => {
          if (changed.type) setAlertType(changed.type);
        }}
        style={{ marginTop: 8 }}
      >
        <Form.Item name="type" label="Alert Type" rules={[{ required: true }]}>
          <Select options={alertTypes} />
        </Form.Item>

        {alertType === 'keyword' && (
          <Form.Item name="keyword" label="Keyword" rules={[{ required: true }]}>
            <Input placeholder="e.g. Sony headphones" />
          </Form.Item>
        )}

        {alertType === 'price_threshold' && (
          <>
            <Form.Item name="minPriceMinor" label="Min Price (cents)">
              <InputNumber min={1} style={{ width: '100%' }} placeholder="e.g. 1000 = $10" />
            </Form.Item>
            <Form.Item name="maxPriceMinor" label="Max Price (cents)">
              <InputNumber min={1} style={{ width: '100%' }} placeholder="e.g. 50000 = $500" />
            </Form.Item>
          </>
        )}

        <Form.Item name="minDiscountPercent" label="Min Discount (%)">
          <InputNumber min={1} max={100} style={{ width: '100%' }} placeholder="e.g. 20" />
        </Form.Item>

        <Form.Item name="frequency" label="Frequency" rules={[{ required: true }]}>
          <Select
            options={[
              { value: 'realtime', label: 'Real-time' },
              { value: 'daily_digest', label: 'Daily Digest' },
              { value: 'weekly_digest', label: 'Weekly Digest' },
            ]}
          />
        </Form.Item>

        {initialValues && (
          <Form.Item name="isActive" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
